import { Product, Category, AppOrder, CartItem } from '../types/pos.types';

export const mockProducts: Product[] = [
  {
    id: "1",
    name: "Sándwich Clásico",
    description: "Pollo, palta, tomate, lechuga",
    price: 12.00,
    category: "sandwiches",
    presentation: "Unidad",
    stock: 25,
    image: "/images/sandwich-clasico.jpg"
  },
  {
    id: "2",
    name: "Sándwich Royal",
    description: "Pollo, jamón, queso, palta, tomate",
    price: 18.00,
    category: "sandwiches",
    presentation: "16ONZ",
    stock: 15,
    image: "/images/sandwich-royal.jpg"
  },
  {
    id: "3",
    name: "Coca Cola 500ml",
    description: "Bebida gaseosa refrescante",
    price: 5.00,
    category: "bebidas",
    presentation: "Unidad",
    stock: 50,
    image: "/images/coca-cola.jpg"
  },
  {
    id: "4",
    name: "Inca Kola 500ml",
    description: "La bebida del Perú",
    price: 5.00,
    category: "bebidas",
    presentation: "Unidad",
    stock: 40,
    image: "/images/inca-kola.jpg"
  },
  {
    id: "5",
    name: "Papas Fritas",
    description: "Papas fritas crujientes",
    price: 8.00,
    category: "extras",
    presentation: "Unidad",
    stock: 20,
    image: "/images/papas-fritas.jpg"
  },
  {
    id: "6",
    name: "Sándwich Vegetariano",
    description: "Palta, tomate, lechuga, queso, cebolla",
    price: 14.00,
    category: "sandwiches",
    presentation: "12ONZ",
    stock: 12,
    image: "/images/sandwich-vegetariano.jpg"
  },
  {
    id: "7",
    name: "Yuca Frita",
    description: "Yuca frita dorada y crujiente",
    price: 6.50,
    category: "extras",
    presentation: "Unidad",
    stock: 18,
    image: "/images/yuca-frita.jpg"
  },
  {
    id: "8",
    name: "Plátano Frito",
    description: "Plátano maduro frito",
    price: 5.00,
    category: "extras", 
    presentation: "Unidad",
    stock: 15,
    image: "/images/platano-frito.jpg"
  },
  {
    id: "9",
    name: "Agua San Luis 500ml",
    description: "Agua mineral natural",
    price: 3.00,
    category: "bebidas",
    presentation: "Unidad",
    stock: 60,
    image: "/images/agua-san-luis.jpg"
  },
  {
    id: "10",
    name: "Chicha Morada 500ml",
    description: "Bebida tradicional peruana",
    price: 6.00,
    category: "bebidas",
    presentation: "Unidad",
    stock: 25,
    image: "/images/chicha-morada.jpg"
  },
  {
    id: "11",
    name: "Salsa Criolla",
    description: "Cebolla, tomate y ají amarillo",
    price: 2.00,
    category: "extras",
    presentation: "Unidad",
    stock: 30,
    image: "/images/salsa-criolla.jpg"
  },
  {
    id: "12",
    name: "Salsa Huancaína",
    description: "Salsa cremosa de ají amarillo",
    price: 3.00,
    category: "extras",
    presentation: "Unidad",
    stock: 25,
    image: "/images/salsa-huancaina.jpg"
  }
];

export const mockCategories: Category[] = [
  { id: "all", name: "Todos", icon: "📦" },
  { id: "sandwiches", name: "Sándwiches", icon: "🥪" },
  { id: "bebidas", name: "Bebidas", icon: "🥤" },
  { id: "extras", name: "Complementos", icon: "🍟" }
];

// Mock data para pedidos del aplicativo
export const mockAppOrders: AppOrder[] = [
  {
    id: "app-001",
    orderNumber: "APP001",
    customerName: "María García",
    customerPhone: "+51 987654321",
    customerAddress: "Av. Javier Prado 123, San Isidro",
    items: [
      {
        id: "item-1",
        product: mockProducts[0], // Sándwich Clásico
        quantity: 2,
        subtotal: 24.00
      },
      {
        id: "item-2", 
        product: mockProducts[2], // Coca Cola
        quantity: 2,
        subtotal: 10.00
      }
    ],
    totals: {
      subtotal: 28.81,
      igv: 5.19,
      total: 34.00
    },
    paymentMethod: 'aplicativo',
    status: 'pendiente',
    orderTime: new Date(Date.now() - 5 * 60000).toISOString(), // 5 minutos atrás
    estimatedTime: "15 min",
    notes: "Sin palta en los sándwiches",
    deliveryPlatform: 'rappi'
  },
  {
    id: "app-002",
    orderNumber: "APP002", 
    customerName: "Carlos López",
    customerPhone: "+51 912345678",
    items: [
      {
        id: "item-3",
        product: mockProducts[1], // Sándwich Royal
        quantity: 1,
        subtotal: 18.00
      },
      {
        id: "item-4",
        product: mockProducts[4], // Papas Fritas
        quantity: 1,
        subtotal: 8.00
      }
    ],
    totals: {
      subtotal: 22.03,
      igv: 3.97,
      total: 26.00
    },
    paymentMethod: 'yape',
    status: 'preparando',
    orderTime: new Date(Date.now() - 10 * 60000).toISOString(), // 10 minutos atrás
    estimatedTime: "10 min",
    deliveryPlatform: 'pedidosya'
  },
  {
    id: "app-003",
    orderNumber: "APP003",
    customerName: "Ana Rodríguez",
    customerPhone: "+51 998877665",
    customerAddress: "Jr. Los Olivos 456, Miraflores",
    items: [
      {
        id: "item-5",
        product: mockProducts[5], // Sándwich Vegetariano
        quantity: 1,
        subtotal: 14.00
      },
      {
        id: "item-6",
        product: mockProducts[3], // Inca Kola
        quantity: 1,
        subtotal: 5.00
      }
    ],
    totals: {
      subtotal: 16.10,
      igv: 2.90,
      total: 19.00
    },
    paymentMethod: 'aplicativo',
    status: 'preparando',
    orderTime: new Date(Date.now() - 15 * 60000).toISOString(), // 15 minutos atrás
    estimatedTime: "5 min",
    notes: "Delivery programado para las 1:30 PM",
    deliveryPlatform: 'pedidosya'
  }
];